module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lOAWe0/tc-custom/9781439675618.jpg?1705026307309",
      "alt": "This image is the cover for the book New Mexico Native American Lore"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New Mexico Native American Lore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Pull on the uncanny threads from the legendary tapestry of New Mexico's Native American heritage.")])]), _c('p', [_vm._v("Ancient Indian history and present Native American cultures are woven together in the Land of Enchantment. The threads of these tales stretch back to Mimbres burial grounds and prehistoric trade routes. Stories and traditions tie the land to its people, in spite of the cycles of slaughter and theft that have threatened to pluck them apart. Descend into the kivas of Chaco Canyon or seek out the high mountains where the clouds mark the stones. From legends of the Salt Woman to the legacy of the Ghost Dance, Ray John de Aragon examines the mysteries of the mesas.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ray John de Aragon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ray John de Aragón is a recognized ethnohistorian. He has spent years studying the characteristics and origins of New Mexico's native cultures. As a university student at the University of Albuquerque, the author was very actively involved in social justice issues. He often spoke about Native American and Chicano rights. After graduation, De Aragón worked as an outside advisor to the Multicultural Enrichment program of the university. After many years of research and studies, he decided to reveal hidden truths and legends to the world about the celebrated Indian tribes of New Mexico.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0